import { render, staticRenderFns } from "./AccountEditPage.vue?vue&type=template&id=6bb4a06a&"
import script from "./AccountEditPage.vue?vue&type=script&lang=js&"
export * from "./AccountEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports